import React, { useEffect, useState, Fragment } from 'react';
import { Clock } from 'lucide-react';
function getTargetDate() {
  const stored = localStorage.getItem('countdown_target');
  if (stored) {
    const target = new Date(stored);
    if (target.getTime() > Date.now()) return target;
  }
  const target = new Date(Date.now() + 2 * 60 * 60 * 1000);
  localStorage.setItem('countdown_target', target.toISOString());
  return target;
}
export function CountdownTimer() {
  const [target] = useState(getTargetDate);
  const [timeLeft, setTimeLeft] = useState({
    h: 0,
    m: 0,
    s: 0
  });
  useEffect(() => {
    const tick = () => {
      const diff = Math.max(0, target.getTime() - Date.now());
      setTimeLeft({
        h: Math.floor(diff / 3600000),
        m: Math.floor(diff % 3600000 / 60000),
        s: Math.floor(diff % 60000 / 1000)
      });
    };
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [target]);
  const pad = (n: number) => String(n).padStart(2, '0');
  return <div className="bg-brand-coral text-white py-3 px-4" data-id="element-15">
      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4" data-id="element-16">
        <div className="flex items-center gap-2" data-id="element-17">
          <Clock className="w-4 h-4" data-id="element-18" />
          <span className="font-bold text-sm uppercase tracking-wide" data-id="element-19">
            ⚠️ Oferta termina en:
          </span>
        </div>
        <div className="flex items-center gap-1.5" data-id="element-20">
          {[{
          val: pad(timeLeft.h),
          label: 'Hrs'
        }, {
          val: pad(timeLeft.m),
          label: 'Min'
        }, {
          val: pad(timeLeft.s),
          label: 'Seg'
        }].map((unit, i) => <Fragment key={i} data-id="element-21">
              {i > 0 && <span className="text-white/70 font-bold text-lg" data-id="element-22">:</span>}
              <div className="bg-white/20 backdrop-blur-sm rounded-md px-2.5 py-1 min-w-[52px] text-center" data-id="element-23">
                <span className="text-xl font-black tabular-nums" data-id="element-24">
                  {unit.val}
                </span>
                <span className="text-[10px] uppercase block -mt-0.5 opacity-80" data-id="element-25">
                  {unit.label}
                </span>
              </div>
            </Fragment>)}
        </div>
      </div>
    </div>;
}